import type { FC, PropsWithChildren } from "react";

interface PricingCardProps extends PropsWithChildren {
	header: string;
	title: string;
	content: React.ReactNode;
}

export const PricingCard: FC<PricingCardProps> = (props) => {
	return (
		<div className="pricing-card">
			<div className="pricing-card-header">{props.header}</div>
			<div className="pricing-card-title">{props.title}</div>

			<div className="pricing-card-content">{props.content}</div>

			<div className="pricing-card-deal">{props.children}</div>
		</div>
	);
};

export const PricingCardList: FC<PropsWithChildren> = (props) => {
	return <div className="pricing-card-list">{props.children}</div>;
};
